import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class HttpService {
   // public  mainRootURl = 'http://localhost/melkam-wetat-registration-api/public';  // Test Server
  //public  mainRootURl = 'http://localhost:8000';  // Test Server
  // public  mainRootURl = 'http://192.168.1.34/melkam-wetat-registration-api/public';  // Test Server

  //public  mainRootURl = 'http://localhost:8000';  // Test Server
  //
   public  mainRootURl = 'httpss://eventapi2015.melkamwetat.com';  // Production Server
  public  rootURl = this.mainRootURl + '/api/';  // Test Server

  // Setting values
  public SETTING_IS_REGISTRATION_OPEN = "is_registration_open";
  public SETTING_CURRENT_ROUND = "current_round";
  public SETTING_MAX_PERSONS_PER_ROUND = "max_persons_per_round";
  public SETTING_MAX_PERSONS_PER_COORDINATOR= "max_persons_per_coordinator";
  public SETTING_SMS_SERVER= "sms_server";
  public SETTING_NEGARIT_API_KEY= "negarit_api_key";
  public SETTING_CBE_ACCOUNT_NUMBER= "cbe_account_number";
  public SETTING_HELP_AUTO_REPLAY = "sms_help";

  constructor(private httpRequest: HttpClient) {
  }

  public sendGetRequest(routeName) {
    return this.httpRequest.get(this.rootURl + routeName);
  }

  public sendPostRequest(routeName, body, header) {
    return this.httpRequest.post(this.rootURl + routeName, body, header);
  }

  public sendPutRequest(routeName, body, header) {
    return this.httpRequest.put(this.rootURl + routeName, body, header);
  }

  public sendDeleteRequest(routeName) {
    return this.httpRequest.delete(this.rootURl + routeName);
  }

  public sendCustomGetRequest(full_url) {
    return this.httpRequest.get(full_url);
  }

  public sendCustomPostRequest(full_url, body, header) {
    return this.httpRequest.post(full_url, body, header);
  }

  public sendCustomPutRequest(full_url, body, header) {
    return this.httpRequest.put(full_url, body, header);
  }

  public sendCustomDeleteRequest(id) {
    return this.httpRequest.delete(id);
  }

}




// WEBPACK FOOTER //
// ./src/app/services/http.service.ts